import $ from 'jquery';

const openCartButton = $('#open-cart-btn');
const closeCartButton = $('.SidebarCart__close');
const sidebarCart = $('.SidebarCart');

export const handleOpenCart = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    sidebarCart.addClass('active');
    $('#main-content').addClass('blured');
};

const handleCloseCart = (ev) => {
    ev.preventDefault();
    sidebarCart.removeClass('active');
    $('#main-content').removeClass('blured');
};

$(document).on('click', '#main-content.blured', handleCloseCart);

openCartButton.on('click', handleOpenCart);

closeCartButton.on('click', handleCloseCart);

const handleRemoveItemFromCart = (ev) => {
    ev.preventDefault();
    sidebarCart.addClass('is-loading');
    const productKey = $(ev.target).closest('button').attr('data-key');

    $.ajax({
        type: 'GET',
        url: jsData.ajaxUrl,
        data: {
            action: 'remove_item_from_cart',
            productKey,
        },
        success: (response) => {
            $(document.body).trigger('updated_cart_totals');
            $(document.body).trigger('wc_fragment_refresh');
        },
    });
};

$(document).on('click', 'button.remove', handleRemoveItemFromCart);

const handleEmptyCart = (ev) => {
    ev.preventDefault();

    if (sidebarCart.hasClass('is-loading')) {
        return;
    }

    sidebarCart.addClass('is-loading');

    $.post(
        jsData.ajaxUrl,
        {
            action: 'verenza_empty_cart',
        },
        () => {
            $(document.body).trigger('updated_cart_totals');
            $(document.body).trigger('wc_fragment_refresh');
        },
        'json',
    ).always(() => {
        sidebarCart.removeClass('is-loading');
    });
};

$(document).on('click', '.SidebarCart__clear', handleEmptyCart);

const updateCartItems = () => {
    sidebarCart.addClass('is-loading');
    $.ajax({
        type: 'GET',
        url: jsData.ajaxUrl,
        data: {
            action: 'verenza_get_cart_items',
        },
        success: (response) => {
            sidebarCart.removeClass('is-loading');
            sidebarCart.find('#sidebar-cart-count').html(response.cart_count);
            sidebarCart.find('#sidebar-cart-total').html(response.cart_total);
            sidebarCart.find('.SidebarCart__mainContent').html(response.cart_items);
            if (window.initializeCounters) {
                window.initializeCounters(sidebarCart[0]);
            }
        },
    });
};

$(document.body).on('added_to_cart updated_cart_totals wc_cart_emptied', updateCartItems);

$(window).on('load', () => {
    $('.SidebarCart').addClass('ready');
});

document.addEventListener('DOMContentLoaded', () => {
    updateCartItems();
});

// verenza_update_cart_quantity

$(document).on('change', '.CartItem__quantity-select', function () {
    const select = $(this);
    const key = select.data('key');
    const rawQty = +select.val();
    const qty = Math.max(1, Math.min(5, rawQty || 1));

    if (qty !== rawQty) {
        select.val(qty);
    }

    select.addClass('is-updating');

    $.post(
        jsData.ajaxUrl,
        {
            action: 'verenza_update_cart_quantity',
            cart_item_key: key,
            quantity: qty,
        },
        function (resp) {
            $(document.body).trigger('updated_cart_totals');
        },
        'json',
    );
});
